import { Component, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { MenuFunctionalityEnum } from 'src/app/shared/menu/menu.functionality.enum';
import { MenuModuleEnum } from 'src/app/shared/menu/menu.module.enum';
import { AlertService, AlertType } from 'src/app/shared/services/alert.service';
import { SelfTriageCounselingService } from 'src/app/shared/services/API/self-triage/self-triage-counseling.service';
import { SelfTriageCounselingModel } from 'src/app/shared/services/models/self-triage/self-triage-counseling.model';
import { UtilService } from 'src/app/shared/services/util.service';
import { SelfTriageCounselingDeleteModalComponent } from './self-triage-counseling-delete-modal/self-triage-counseling-delete-modal.component';

@Component({
  selector: 'app-self-triage-counseling-list',
  templateUrl: './self-triage-counseling-list.component.html',
  styleUrls: ['./self-triage-counseling-list.component.css']
})
export class SelfTriageCounselingListComponent implements OnInit {

  constructor(private selfTriageCounselingService: SelfTriageCounselingService,
    private router: Router,
    private alertService: AlertService,
    private utilService: UtilService,
    public dialog: MatDialog,
  ) { }

  public menuModuleEnum: MenuModuleEnum = MenuModuleEnum.consulting;
  public menuFunctionalityEnum: MenuFunctionalityEnum = MenuFunctionalityEnum.consulting_self_triage_counseling;

  public listSelfTriageCounseling: SelfTriageCounselingModel[];
  public isLoading: boolean;
  public searchText: string;

  ngOnInit(): void {
    this.isLoading = true;
    this.search();
  }
  search() {
    this.isLoading = true;
    if (this.searchText == "")
      this.searchText = null;

    this.selfTriageCounselingService.listCounseling(this.searchText).subscribe((response) => {

      if (response.isError) {
        this.alertService.show('Erro', response.errorDescription, AlertType.error);
        this.isLoading = false;
        return;
      }

      this.listSelfTriageCounseling = response.listSelfTriageCounseling;

      this.isLoading = false;
    },
      (error) => {
        console.log(error)
        this.isLoading = false;
        this.alertService.show('Erro inesperado', error, AlertType.error);
      });
  }

  private timeoutKeySearch: any = null;

  onKeySearch(event: any) {
    clearTimeout(this.timeoutKeySearch);
    var $this = this;
    this.timeoutKeySearch = setTimeout(function () {
      if (event.keyCode != 13) {
        $this.search();
      }
    }, 1000);
  }

  openModal(idSelfTriageCounseling) {
    const dialogRef = this.dialog.open(SelfTriageCounselingDeleteModalComponent, {
      data: {
        idSelfTriageCounseling: idSelfTriageCounseling,
      },
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result && result.deleteCounseling) {
        this.search();
      }
    });
  }
}